export default __webpack_public_path__ + "static/media/dome.6583ca5f.png";